<template>
	<div class="timer">
		<span class="timer--countdown">{{ timeLeft }}</span>
	</div>
</template>

<script>
export default {
	props: {
		seconds: Number
	},

	data() {
		return {
			intervalTimer: null,
			timeLeft: '00:00'
		}
	},

	methods: {
		timer(seconds) {
			const now = Date.now()
			const end = now + seconds * 1000
			this.displayTimeLeft(seconds)

			this.countdown(end)
		},

		countdown(end) {
			this.intervalTimer = setInterval(() => {
				const secondsLeft = Math.round((end - Date.now()) / 1000)

				if (secondsLeft < 0) {
					return clearInterval(this.intervalTimer)
				}
				this.displayTimeLeft(secondsLeft)
			}, 1000)
		},

		displayTimeLeft(secondsLeft) {
			const minutes = Math.floor((secondsLeft % 3600) / 60)
			const seconds = secondsLeft % 60

			this.timeLeft = `00:${zeroPadded(minutes)}:${zeroPadded(seconds)}`
		}
	},

	created() {
		this.timer(this.seconds)
	}
}

function zeroPadded(num) {
	return num < 10 ? `0${num}` : num
}
</script>

<style lang="scss">
.timer {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 3.6vh 0;

	&--countdown {
		font-size: 3.2rem;
		font-weight: bold;
		color: #6a79e5;
	}
}
</style>
